<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: flex-end;">
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">
                                <h2 class="title">{{ isNew ? 'New' : 'Edit' }} Location</h2>
                                <p class="sub--title">* is a required field</p>
                                <form>
                                    <div class="row row-space">
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Region Code<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.region_code"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Region Code"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Parent Code</label>
                                                <input
                                                    v-model="form.parent_code"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Parent Code"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Location Code<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.loc_code"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Location Code"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Alias Code</label>
                                                <input
                                                    v-model="form.alias_code"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Alias Code"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Name<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.name"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Name"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Type<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.type"
                                                    :options="options.type"
                                                    placeholder="Choose Type"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Karesidenan</label>
                                                <MultiSelect
                                                    v-model="form.karesidenan"
                                                    :options="options.karesidenan.map(x => x.code)"
                                                    :custom-label="opt => options.karesidenan.find(x => x.code == opt).name"
                                                    placeholder="Choose Karesidenan"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">City</label>
                                                <MultiSelect
                                                    v-model="form.city"
                                                    :options="options.city.map(x => x.code)"
                                                    :custom-label="opt => options.city.find(x => x.code == opt).name"
                                                    placeholder="Choose city"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Address</label>
                                                <input
                                                    v-model="form.address"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Address"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Email</label>
                                                <input
                                                    v-model="form.email"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Email"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Latitude</label>
                                                <input
                                                    v-model="form.lat"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Latitude"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Longitude</label>
                                                <input
                                                    v-model="form.lng"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Longitude"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6 offset-md-3" v-if="!isNew">
                                            <div class="input-group">
                                                <label class="label">Status<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.is_active"
                                                    :options="options.is_active.map(x => x.value)"
                                                    :custom-label="opt => options.is_active.find(x => x.value == opt).title"
                                                    :allow-empty="false"
                                                    placeholder="Choose Status"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col mt-5" style="text-align: center">
                                            <button type="button" class="btn btn-outline-danger" style="font-size:140%"
                                                @click="$emit('closeModal')">Cancel</button>
                                            <button type="button" class="btn btn-primary ml-5" style="font-size:150%"
                                                @click="submitForm()">{{ isNew ? 'Create' : 'Edit' }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import MultiSelect from 'vue-multiselect';

    export default {
        data() {
            let user = this.$store.getters.currentUser

            return {
                dataReady : false,
                mobile: this.isMobile(),
                isNew : true,
                options : {
                    type : ['MAINDEALER', 'AHASS', 'DEALER'],
                    is_active : [
                        {title:'Active', value: 'active'},
                        {title:'Inactive', value: 'inactive'},
                    ],
                    karesidenan : this.$store.getters.getKaresidenan,
                    city : this.$store.getters.getCityBySingleId(),
                },
                form: {
                    loc_code : null,
                    parent_code : null,
                    region_code : null,
                    name : null,
                    type : null,
                    karesidenan : null,
                    address : null,
                    city : null,
                    email : null,
                    lat : null,
                    lng : null,
                    alias_code : null,
                    is_active : null,
                },
            }
        },
        props : ['data'],
        components: {
            MultiSelect,
        },
        async mounted() {
            if (this.data) await this.convertEdit();
        },
        watch: {
            'form.karesidenan' () {
                this.options.city = this.$store.getters.getCityBySingleId(this.form.karesidenan);
                this.form.city = '';
            },
        },
        methods: {
            convertEdit() {
                this.isNew = false;

                this.form.id = this.data.id;
                this.form.loc_code = this.data.loc_code;
                this.form.parent_code = this.data.parent_code;
                this.form.region_code = this.data.region_code;
                this.form.name = this.data.name;
                this.form.type = this.data.type;
                this.form.karesidenan = this.data.karesidenan;
                this.form.address = this.data.address;
                setTimeout(()=>{
                    this.form.city = this.data.city;
                }, 10)
                this.form.email = this.data.email;
                this.form.lat = this.data.lat;
                this.form.lng = this.data.lng;
                this.form.alias_code = this.data.alias_code;
                this.form.is_active = this.data.is_active.toLowerCase();
            },
            notNullObject (obj) {
                let ret = {}
                for (var i in obj) if(obj[i] !== null && obj[i] !== '')ret[i] = obj[i]
                return ret;
            },
            validateForm() {
                let errors = [];

                // Loc Code
                if (!this.form.loc_code) errors.push('<strong>Loc Code</strong> is a required field!');

                // Region Code
                if (!this.form.region_code) errors.push('<strong>Region Code</strong> is a required field!');

                // Name
                if (!this.form.name) errors.push('<strong>Name</strong> is a required field!');

                // Type
                if (!this.form.type) errors.push('<strong>Type</strong> is a required field!');

                // EDIT MODE
                if (!this.isNew) {
                    // Status
                    if (!this.form.is_active) errors.push('<strong>Status</strong> is a required field!');
                }

                if (errors.length > 0) {
                    this.$swal.fire({
                        title : "Error!",
                        icon : "error",
                        type : "error",
                        html : errors.join("<br>")
                    })
                    return false;
                } else 
                    return true;
            },
            async submitForm() {
                let vm = this;

                if (await vm.validateForm()) {
                    let method = this.isNew ? 'post' : 'put';
                    let url = this.isNew ? '/api/setting/add-location' : `/api/setting/update-location`;

                    //Convert is_active from 'active' and 'inactive' to 1 and 0 respectively
                    let form = JSON.parse(JSON.stringify(this.form));
                    form['is_active'] = form['is_active'] == 'active' ? 1 : 0;

                    this.$http[method](url, await this.notNullObject(form))
                    .then((resp) => {
                        // alert(`Partshop ${vm.form.name} has been created`);
                        this.$swal.fire({
                            title : "Success!",
                            icon : "success",
                            text : `${this.form.loc_code} - ${this.form.name} has been successfully created`
                        })
                        //Load Filter Options
                        this.loadFilterOptions('dealer');
                        this.loadFilterOptions('gudang');

                        this.$emit('refreshData');
                        this.$emit('closeModal');
                    })
                    .catch((err) => {
                        console.log(err);
                        if (Array.isArray(err.response.data.data.details)) {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                html : err.response.data.data.details.map(x=>x.message).join("<br>")
                            })
                        } else {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : err.response.data.message
                            })
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
        outline: none;
        margin: 0;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        width: 100%;
        font-size: 14px;
        font-family: inherit;
    }

    .input--style-4 {
        line-height: 50px;
        background: #fafafa;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        -webkit-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -moz-transition: all 0.4s ease;
        transition: all 0.4s ease;
    }

    .input--style-4::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #666;
    }

    .input--style-4:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #666;
        opacity: 1;
    }

    .input--style-4::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #666;
        opacity: 1;
    }

    .input--style-4:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666;
    }

    .input--style-4:-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666;
    }

    .label {
        font-size: 16px;
        color: #555;
        text-transform: capitalize;
        display: block;
        margin-bottom: 5px;
    }

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .radio-container input:checked~.checkmark {
        background-color: #e5e5e5;
    }

    .radio-container input:checked~.checkmark:after {
        display: block;
    }

    .radio-container .checkmark:after {
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 12px;
        height: 12px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: #57b846;
    }

    .checkmark {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e5e5e5;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .input-group {
        position: relative;
        /* margin-bottom: 22px; */
        padding: 20px;
    }

    .input-group-icon {
        position: relative;
    }

    .input-icon {
        position: absolute;
        font-size: 18px;
        color: #999;
        right: 18px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
    }

    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
        font-size: 40px;
        color: #525252;
        /* margin-bottom: 40px; */
        text-align: center;
    }

    .sub--title {
        color: red;
        margin-bottom: 40px;
        text-align: center;
    }



    .input--style-4:disabled {
        background: #cfcfcf;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }
</style>